import { render, staticRenderFns } from "./document-tags-table.vue?vue&type=template&id=19453c58"
import script from "./document-tags-table.vue?vue&type=script&lang=js"
export * from "./document-tags-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports